import { connectToQzTrayServer } from 'component_utils/peripherals/peripheralPrinters/QZTray';
import { fromPairs } from 'lodash';
import moment from 'moment';
import React from 'react';
import * as Reactstrap from 'reactstrap';
import { CostumerIdMappings } from 'specialization';
import { getOneTimeInputFromPeripheral } from 'utils/PeripheralManager';
const parser = require("gs1-barcode-parser-mod")

declare global {
  interface Window {
    __customizer_lib_loaders: {[k:string]: () => Promise<any>};
    __customizer_libs: {[k:string]: any};
    __customizer_import: (file: string) => Promise<any>;
  }
}

const stateImplementationsRequire = (require as any).context(
  'components/StateMachine/states', 
  true, 
  /\.tsx$/
); 
const objectComponents = (require as any).context(
  'components/objects', 
  true, 
  /index\.tsx$/
); 

export default () => {
  const w = window as any;
  w.moment = moment
  w.React = React;
  w.Reactstrap = Reactstrap;
  w.GS1BarcodeParser = {
    parseBarcode: (s: string) => {
      // if the barcode has (01)12345(17)123123
      // then remove them and add seperators between the parts
      // if there are <GS> replacements in the barcode then replace them with the actual value
      let cleaned = s.trim()
      cleaned = cleaned.replaceAll("<GS>", "\x1D")
      cleaned = cleaned.replaceAll("(", "\x1D").replaceAll(")", "")
      if (cleaned[0] === "\x1D") {
        cleaned = cleaned.substring(1)
      }

      return parser.parseBarcode(cleaned)
    }
  };


  // setup the customizer libraries and frameworks
  window.__customizer_lib_loaders = {
    "be-efficient/ui/form-state": () => import("component_utils/FormUtils"),
    "be-efficient/ui/simple-modal": () => import("components/SimpleModal"),
    "be-efficient/ui/state-machine": () => import("components/StateMachine"),
    "be-efficient/ui/be-table": () => import("components/BeTable"),
    "be-efficient/ui/date": () => import("components/Date"),
    "be-efficient/ui/tri-state-checkbox": () => import("components/TriStateCheckbox"),
    "be-efficient/ui/expanded-indicator": () => import("components/ExpandedIndicator"),
    "be-efficient/ui/processing-button": () => import("components/ProcessingButton"),
    "be-efficient/ui/loader-overlay": () => import("components/LoaderOverlay"),
    "be-efficient/ui/linkable": () => import("components/Linkable"),
    "be-efficient/ui/if": () => import("components/If"),
    "be-efficient/ui/raw": () => import("components/Raw"),
    "be-efficient/ui/mount-unmound": () => import("components/MountUnmount"),
    "be-efficient/ui/portal": () => import("components/Portal"),
    "be-efficient/ui/scanner": () => import("components/Scanner"),
    "be-efficient/ui/role-protected": () => import("components/RoleProtected"),
    "be-efficient/ui/pdf-viewer": () => import("components/PdfViewer"),
    "be-efficient/ui/picture-box": () => import("components/PictureBox"),
    "be-efficient/ui/uncontrolled-tabs": () => import("components/uncontrolled_tabs"),
    "be-efficient/ui/application-title-appendix": () => import("components/ApplicationTitleAppendix"),
    "be-efficient/ui/prompts": () => import("utils/Prompts"),
    "be-efficient/ui/react-datasheet-grid": () => import("components/ReactDatasheetGrid"),
    "be-efficient/ui/react-datasheet-grid/fixers": () => import("components/datasheetUtils/fixers"),
    "be-efficient/ui/react-datasheet-grid/components": () => import("components/datasheetUtils/general/utils"),
    "be-efficient/ui/table-extractor": () => import("component_utils/TableUtils"),
    "be-efficient/ui/i18n": () => import("utils/Language/Translation"),
    "be-efficient/ui/property-list": () => import("components/property_list"),
    "be-efficient/ui/reactstrap": () => import("reactstrap"),
    "be-efficient/ui/react-icons/fa": () => import("react-icons/fa"),
    "be-efficient/ui/react-icons/fc": () => import("react-icons/fc"),
    "be-efficient/ui/react-icons/ai": () => import("react-icons/ai"),
    "be-efficient/ui/react-icons/ri": () => import("react-icons/ri"),
    "be-efficient/ui/react-icons/bs": () => import("react-icons/bs"),
    "be-efficient/ui/react-icons/io": () => import("react-icons/io"),
    "be-efficient/ui/react-icons/si": () => import("react-icons/si"),
    "be-efficient/ui/react-icons/md": () => import("react-icons/md"),
    "be-efficient/ui/react-icons/gi": () => import("react-icons/gi"),
    "be-efficient/ui/react-resizable": () => import("react-resizable"),
    "be-efficient/ui/react-draggable": () => import("react-draggable"),
    "be-efficient/ui/react-grid-layout": () => import("react-grid-layout"),
    "be-efficient/ui/daypilot-lite-react": () => import("@daypilot/daypilot-lite-react"),
    "be-efficient/ui/react-table-library-theme": () => import("@table-library/react-table-library/theme"),
    "be-efficient/ui/react-table-library-baseline": () => import("@table-library/react-table-library/baseline"),
    "be-efficient/ui/react-table-library-compact": () => import("@table-library/react-table-library/compact"),
    "be-efficient/ui/react-table-library-composed": () => import("@table-library/react-table-library/table"),
    "be-efficient/api": () => import("utils/API"),
    "be-efficient/config": () => import("utils/Config"),
    "be-efficient/routing": () => import("statics/route_data"),
    "be-efficient/notifications": () => import("utils/NotificationManager"),
    "be-efficient/utils/zip": () => import('jszip'),
    "be-efficient/utils/deliveries": async () => {
      const m = await import('routes/outbound/PickAndCollect/process')
      const m2 = await import('routes/outbound/delivery/process')
      return {
        deliverPickAndCollectGroup: m.deliverPickAndCollectGroup,
        getUnderOverStocked: m.getUnderOverStocked,
        getStockPerOrderLines: m.getStockPerOrderLines,
        createDelivery: m2.createDelivery
      }
    },
    "be-efficient/utils/lodash": () => import("lodash"),
    "be-efficient/utils/classnames": () => import("classnames"),
    "be-efficient/utils/objects/utils": () => import("component_utils/objectUtils"),
    "be-efficient/utils/use-resize-detector": () => import("components/useResizeDetector"),
    "be-efficient/utils/misc": () => import("component_utils/utils"),
    "be-efficient/utils/fit-text": () => import("components/FitText"),
    "be-efficient/utils/file-saver": () => import("file-saver"),
    "be-efficient/utils/pdf-lib": () => import("pdf-lib"),
    "be-efficient/utils/xlsx": () => import("xlsx"),
    "be-efficient/utils/exceljs": () => import("exceljs"),
    "be-efficient/utils/history-state": () => import("component_utils/useHistoryState"),
    "be-efficient/utils/async-object-cache": () => import("component_utils/AsyncObjectCache"),
    "be-efficient/utils/moment": () => Promise.resolve({ default: moment }),
    "be-efficient/utils/immutable": () => import("object-path-immutable"),
    "be-efficient/utils/dndkit/core": () => import('@dnd-kit/core'),
    "be-efficient/utils/dndkit/sortable": () => import('@dnd-kit/sortable'),
    "be-efficient/utils/dndkit/utilities": () => import('@dnd-kit/utilities'),
    "be-efficient/utils/audio/beep.mp3": () => import('components/barcode_scanner/beep.mp3'),
    "be-efficient/utils/audio/serialSound.mp3": () => import('audio/serialSound.mp3'),
    "be-efficient/utils/audio/victory.mp3": () => import('audio/victory1.mp3'),
    "be-efficient/utils/audio/alarm.mp3": () => import('audio/alarm.mp3'),
    "be-efficient/utils/one-time-input": () => Promise.resolve({ 
      default: (...args: Parameters<typeof getOneTimeInputFromPeripheral>) => getOneTimeInputFromPeripheral(...args) 
    }),
    "be-efficient/utils/gs1parser": () => Promise.resolve({ default: parser }),
    "be-efficient/utils/qz-tray": async () => {
      const result = await import("qz-tray");
      (result as any).connectToQzTrayServer = connectToQzTrayServer;
      return result;
    },
    "be-efficient/premade-specializations/lt": CostumerIdMappings['lankhorst_taselaar'],
    "be-efficient/premade-specializations/hcm": CostumerIdMappings['HCM'],
    "be-efficient/premade-specializations/ils": CostumerIdMappings['ILS'],
    "react": () => import("react"),

    ...fromPairs(objectComponents.keys().map((k: string) => {
      const parts = k.split("/").filter(Boolean); // remove empty segments
      const objectName = parts[parts.length - 2];
      const path = "be-efficient/ui/objects/" + objectName
      return [path, () => objectComponents(k)]
    })),

    ...fromPairs(stateImplementationsRequire.keys().map((k: string) => {
      const path = "be-efficient/ui/state-machine/" + k.replace(/^.*\/([^/]+)$/, "$1")
      return [path, () => stateImplementationsRequire(k)]
    }))
  }
  window.__customizer_libs = {}
  window.__customizer_import = async (lib: string) => {
    if (Object.keys(window.__customizer_libs).indexOf(lib) !== -1) {
      console.log("already loaded library", lib)
      return window.__customizer_libs[lib];
    }

    console.log("loading library", lib)
    if (Object.keys(window.__customizer_lib_loaders).indexOf(lib) !== -1) {
      // known library from be-efficient
      window.__customizer_libs[lib] = await window.__customizer_lib_loaders[lib]()
    } else {
      // most likely a chunk
      const res = await fetch(lib);
      const text = await res.text();
      
      // eslint-disable-next-line no-new-func
      const module = new Function(text)();
      await module.loadLibs()
      const loaded = module.initialize()
      window.__customizer_libs[lib] = loaded
    }

    return window.__customizer_libs[lib];
  }
};
